import React from 'react';
import AdminLayout from 'cms/core/shared/AdminLayout';
import CVList from '../components/CVList';

function CVScreen() {
    return (
        <AdminLayout pageTitle="CVs">
            <CVList />
        </AdminLayout>
    );
}

export default CVScreen;

